import { gql } from "@apollo/client";
const FailedUploadMutation = gql`
  mutation FailedUploadMutation(
    $filename: String!
    $problem: String
    $relativePath: String
    $uploadId: BigInt!
  ) {
    createFailedFile(
      input: {
        failedFile: {
          filename: $filename
          problem: $problem
          relativePath: $relativePath
          uploadId: $uploadId
        }
      }
    ) {
      failedFile {
        filename
      }
    }
  }
`;

const hash = "e2e12f65ca03ed096eed94c1a20a0fff286e7deb236e8dfa2f07ac73b5528dbc";

export { FailedUploadMutation, hash };
